import React, { Component } from 'react'
import { Icon, Input, message, Modal, Popconfirm, Tag, notification, Button } from "antd"
import ItemImage from "./ItemImage"
import { getInformationConfirmed, updateInformationConfirmed } from "../../../services/api/3dApi"
import convertDateOverTime from '../../../helpers/convertDateOverTime'
import { REASON_ERROR } from '../helper/reasonError'
import { updateMarkError } from "../../../services/api/3dApi"

class MarkItemPrinted extends Component {
    state = {
        inputValue: '',
        errorInput: '',
        loading: false,
        strScan: '',
        itemScan: null,
        loadingQC: false,
        piece_errors: [],
        piece_hovers: [],
        reason_error: REASON_ERROR || [],
        loadingMarkItemError: false,
    }

    _input = React.createRef()

    componentDidMount() {
        this._input.current.focus()
    }

    _onSubmit = (e) => {
        e.preventDefault()
        const { inputValue } = this.state

        const check = /^#\d+_\d+$/.test(inputValue)

        this.setState({
            inputValue: inputValue,
            strScan: inputValue,
            errorInput: !check ? 'Item sai định dạng.' : '',
            completed: true
        }, () => {
            const valueFormatted = inputValue.trim().replace(/^#/, '')

            if (!valueFormatted) {
                return this.setState({
                    errorInput: 'Item sai định dạng.'
                })
            }

            check && this._rqPrintAction(valueFormatted)
        })
    }

    _handleChange = e => {
        let { value } = e.target

        this.setState({
            errorInput: '',
            inputValue: value,
        })
    }

    _rqPrintAction = async (value) => {
        this.setState({
            loading: true
        })

        try {

            const { data: response } = await getInformationConfirmed(`barcode=${value}`)

            const { success, error, data } = response

            if (!success) {
                return this.setState({
                    loading: false,
                    itemScan: null
                }, () => {
                    const { strScan } = this.state

                    Modal.error({
                        title: 'Lỗi',
                        content: <div><strong>{strScan}</strong>: {error}</div>,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng'
                    })
                })
            }

            const { partials = [], batchItem } = data
            const { failed_pieces } = Object.assign({}, batchItem)
            const errorPieces = partials.map(partial => {
                return {
                    url: partial.zone || '',
                    name: partial.name,
                    mark_error: failed_pieces.includes(partial.name) ? true : false
                }
            }
            )

            const newParials = partials.map(partial => {
                if (failed_pieces.includes(partial.name)) {
                    return {
                        ...partial,
                        mark_error: true,
                        isHover: false
                    }
                }
                return {
                    ...partial,
                    mark_error: false,
                    isHover: false
                }
            })

            this.setState({
                loading: false,
                itemScan: {
                    ...data,
                    partials: newParials
                },
                piece_errors: errorPieces
            })


        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _onPaste = (e) => {
        //e.preventDefault()
    }

    _resetScanInput = () => {
        this.setState({
            inputValue: '',
            itemScan: null,
            reason_error: REASON_ERROR
        }, () => {
            this._input.current.focus()
        })
    }

    _submitPrinted = async () => {
        this.setState({
            loadingQC: true
        })

        try {
            const { itemScan } = this.state

            if (itemScan === null) {
                return this.setState({
                    loadingQC: false
                })
            }

            const { barcode_number, item_number } = itemScan
            const numberScan = `${barcode_number}_${item_number}`

            const payload = {
                barcode: numberScan
            }

            const { data: response } = await updateInformationConfirmed(payload)

            const { success, error } = response

            if (!success) {
                return this.setState({
                    loadingQC: false,
                    itemScan: null
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng'
                    })
                })
            }

            this.setState({
                inputValue: '',
                loadingQC: false,
                itemScan: null
            })

            message.success('QC sau ép thành công!')
        } catch (e) {
            this.setState({
                loadingQC: false,
                itemScan: null
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _onQC = (e) => {
        e.preventDefault()

        this._submitPrinted()
    }

    _onMarkError = (e) => {
        e.preventDefault()

        this._onMarkItemError()
    }

    _onMarkItemError = async () => {
        this.setState({
            loadingMarkItemError: true,
        })
        try {
            const { piece_errors, inputValue, itemScan, reason_error } = this.state
            const id = itemScan && !!itemScan.batchItem ? itemScan.batchItem._id : ''

            const failedPieces = piece_errors.filter(piece => piece.mark_error).map(item => item.name)
            const error_detail = reason_error.find(item => item.mark_error) || {}

            if (!error_detail.name) {
                this.setState({ loadingMarkItemError: false })
                return notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: `Bạn cần nhập chi tiết lỗi để đánh dấu lỗi.`,
                })
            }

            const payload = {
                error_type: error_detail.type_error || '',
                error_style: failedPieces.length > 0 ? 'detail' : 'overview',
                error_detail: error_detail.name,
                error_procedure: 'qc_after_transferred',
                failed_pieces: failedPieces.length ? failedPieces : []
            }

            const { data: response } = await updateMarkError(id, payload)

            const { success, message } = response

            if (!success) {
                return this.setState({
                    loadingMarkItemError: false,
                    error: message
                }, () => {
                    notification.error({
                        message: 'Đánh dấu lỗi không thành công',
                        description: `Bạn đã đánh dấu lỗi cho item ${inputValue} không thành công`,
                    })
                })
            }

            this.setState({
                loadingMarkItemError: false,
                error: ''
            }, () => {
                this._resetScanInput()
                notification.success({
                    message: 'Đánh dấu lỗi thành công',
                    description: `Bạn đã đánh dấu lỗi cho item ${inputValue} thành công`,
                })
            })
        } catch (e) {
            this.setState({
                loadingMarkItemError: false,
                error: e.message
            }, () => {
                notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: e.message,
                })
            })
        }
    }

    _handleShowItemError = (partial) => {
        const { piece_errors, itemScan } = this.state
        const { partials } = Object.assign({}, itemScan)
        const newPieceErrors = piece_errors.map(item => {
            if (item.name === partial.name && item.mark_error) {
                return {
                    ...item,
                    mark_error: false
                }
            }

            if (item.name === partial.name && !item.mark_error) {
                return {
                    ...item,
                    mark_error: true
                }
            }

            return item
        })

        const newParials = partials.map(item => {
            if (item.name === partial.name && item.mark_error) {
                return {
                    ...item,
                    mark_error: false
                }
            }

            if (item.name === partial.name && !item.mark_error) {
                return {
                    ...item,
                    mark_error: true
                }
            }

            return item
        })

        this.setState(preState => ({
            piece_errors: newPieceErrors,
            itemScan: {
                ...preState.itemScan,
                partials: newParials
            }
        }))
    }

    _handleShowReasonItemError = reason => {
        const { reason_error } = this.state
        const newReasonError = reason_error.map(item => {
            if (item.name === reason.name && item.mark_error) {
                return {
                    ...item,
                    mark_error: false
                }
            }
            delete item.mark_error
            if (item.name === reason.name && !item.mark_error) {
                return {
                    ...item,
                    mark_error: true
                }
            }
            return item
        })

        this.setState({ reason_error: newReasonError })
    }

    _hanldeMouseOut = partial => {
        const { partials } = Object.assign({}, this.state.itemScan)
        const newParials = partials.map(item => {
            if (item.name === partial.name) {
                return {
                    ...item,
                    isHover: false
                }
            }

            return item
        })

        this.setState({
            piece_hovers: newParials
        })
    }

    _hanldeMouseOver = partial => {
        const { partials } = Object.assign({}, this.state.itemScan)
        const newParials = partials.map(item => {
            if (partial.name === item.name) {
                return {
                    ...item,
                    isHover: true
                }
            }

            return item
        })

        this.setState({
            piece_hovers: newParials
        })
    }

    render() {
        const { loading, loadingQC, inputValue, itemScan, errorInput, piece_errors, piece_hovers, reason_error, loadingMarkItemError } = this.state
        const {
            _id,
            size,
            type,
            image,
            tags,
            preview_image,
            production_status,
            batchItem,
            item_number,
            mock_up_front,
            safezone_image,
            partials,
            brand_tags,
            brand_name,
            overtime,
        } = itemScan || {}

        const { branding } = Object.assign({}, brand_tags)
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
        const isGiftTag = Array.isArray(tags) && tags.includes('gift')
        const isSampleTag = Array.isArray(tags) && tags.includes('sample')
        const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
        const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
        const isCutOffTag = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const isMarkItemError = reason_error.filter(i => i.mark_error).length > 0
        const isSLL = Array.isArray(tags) && tags.includes('SLL')

        return (
            <div className={`MarkItemPrinted p-5 ${itemScan !== null ? '' : 'NoDataScan'}`}>
                <div className='row'>
                    <div className='col-12 mx-auto'>
                        <div className={`d-flex ${itemScan !== null ? 'col-3' : 'col-5'} justify-content-between px-0`} style={{ marginBottom: 20 }}>
                            <h1>
                                QC sau ép
                                {
                                    isSpecialTag && <Tag color="#ff0000" className='mr-2 my-1'>Đặc biệt</Tag>
                                }

                                {   
                                    isGiftTag && <Tag color="#ff0000" className='mr-2 my-1'>Hàng tặng</Tag>
                                }

                                {
                                    isSampleTag && <Tag color="#ff0000" className='mr-2 my-1'>Hàng mẫu</Tag>
                                }

                                {
                                    isFbaTag && <Tag color="#ff0000" className='mr-2 my-1'>FBA</Tag>
                                }

                                {
                                    isFastShipTag && <Tag color="#ff0000" className='mr-2 my-1'>Ship nhanh</Tag>
                                }
                                
                                {!!isSLL &&
                                    <Tag color="#fdb813" className="mr-2 my-1">SLL</Tag>
                                }
                            </h1>
                            {overtime && overtime > 0 &&
                                <div className="OverTime mr-4" >
                                    <label
                                        className='mb-0 mt-2 btn'
                                        style={{
                                            background: 'rgba(255 77 80)',
                                            color: 'white', cursor: 'auto'
                                        }}
                                    >
                                        QUÁ HẠN <label className='font-weight-bold my-0'>{convertDateOverTime(overtime)}</label>
                                    </label>
                                </div>
                            }
                            {overtime && (overtime >= -1 && overtime < 0) &&
                                <div className="OverTime mr-4" >
                                    <label
                                        className='mb-0 mt-2 btn'
                                        style={{
                                            background: '#ffcd3a',
                                            color: 'white', cursor: 'auto'
                                        }}
                                    >
                                        Sắp quá hạn <label className='font-weight-bold my-0'>{convertDateOverTime(overtime)}</label>
                                    </label>
                                </div>
                            }
                        </div>
                        <div className="position-relative">
                            <form onSubmit={this._onSubmit} className="formQC">
                                <div className="row flex-nowrap">
                                    <div className={itemScan !== null ? 'col-3' : 'col-5'}>
                                        <Input
                                            onPaste={this._onPaste}
                                            style={{ fontSize: 40, height: "auto" }}
                                            placeholder='Nhập item cần đánh dấu'
                                            value={inputValue}
                                            ref={this._input}
                                            onChange={this._handleChange}
                                        />
                                        {loading && (
                                            <Icon type="sync" spin className="position-absolute IconInput" />
                                        )}
                                        {(inputValue && !loading) && (
                                            <Icon type="close-circle"
                                                className="position-absolute cursor-pointer IconInput"
                                                onClick={this._resetScanInput}
                                            />
                                        )}

                                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}

                                        {
                                            itemScan !== null && (
                                                <div className="CustomPageQC">
                                                    <div className="ItemImage">
                                                        <div className="infoItem d-flex align-items-center py-3 flex-wrap text-left">
                                                            <span className="Type mx-1">{type}</span>
                                                            <span
                                                                className="badge badge-success badge-pill Status mx-1">
                                                                {production_status}
                                                            </span>
                                                            <span
                                                                className="badge badge-success badge-pill batchName mx-1">
                                                                {batchItem.batch.name}
                                                            </span>
                                                            <span
                                                                className="badge badge-secondary badge-pill Size mx-1">
                                                                {size}
                                                            </span>
                                                            <span
                                                                className="badge badge-secondary badge-pill pos mx-1">
                                                                {item_number}
                                                            </span>
                                                            {
                                                                !!brand_name &&
                                                                <span className='Brand mx-1 badge badge-danger badge-pill py-1 px-2'>
                                                                    {brand_name}
                                                                </span>
                                                            }
                                                            {
                                                                !!branding && (
                                                                    <span className='Brand mx-1 border border-danger text-danger py-1 px-2 my-1'>
                                                                        {branding.map((item, index) => (
                                                                            index ? `, ${item.name}` : item.name
                                                                        ))}
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="ImageMockup">
                                                        <img src={mock_up_front} alt="mockup" />
                                                    </div>
                                                    <div className="my-3 d-flex justify-content-between btnCustom">
                                                        <div>
                                                            <Button size="large" onClick={this._resetScanInput}>Hủy</Button>
                                                            <Popconfirm placement="topRight" overlayClassName='CustomPopConfirmError' title={`Bạn chắc chắn muốn đánh dấu cho sản phẩm này?`}
                                                                onConfirm={this._onMarkError} okText="Đánh dấu lỗi" cancelText="Hủy" disabled={!isMarkItemError}>
                                                                <Button type="danger" danger className="ml-2" size="large" disabled={!isMarkItemError}>
                                                                    {
                                                                        loadingMarkItemError &&
                                                                        <i className="fa fa-spinner fa-spin mr-3" />
                                                                    }
                                                                    {
                                                                        loadingMarkItemError ? 'Đang tải...' : 'Đánh dấu lỗi'
                                                                    }
                                                                </Button>
                                                            </Popconfirm>
                                                        </div>

                                                        <Popconfirm placement="top" overlayClassName='CustomPopConfirm'
                                                            icon={<Icon type="question-circle" />}
                                                            title={`Bạn chắc chắn muốn đánh dấu QC sau ép cho sản phẩm này?`}
                                                            onConfirm={this._onQC} okText="Đánh dấu QC"
                                                            cancelText="Hủy" disabled={isMarkItemError}>
                                                            <Button type="primary" disabled={isMarkItemError} size="large">
                                                                {
                                                                    loadingQC &&
                                                                    <i className="fa fa-spinner fa-spin mr-3" />
                                                                }
                                                                {
                                                                    loadingQC ? 'Đang tải...' : 'QC sau ép '
                                                                }
                                                            </Button>
                                                        </Popconfirm>
                                                    </div>
                                                </div>

                                            )
                                        }
                                    </div>
                                    <div className="col-auto mr-auto position-relative" style={{ maxWidth: 765 }}>
                                        <div className="d-flex Fastproduction w-100" style={{top: -60}}>
                                            {
                                                isFastProductionTag && 
                                                <span className='mr-3'>Sản xuất nhanh</span>
                                            }
                                            {
                                                isTikTokTag && 
                                                <span className='mr-3 tiktok'>TIKTOK</span>
                                            }
                                            {
                                                isCutOffTag && 
                                                <span className='mr-3'>Cutoff</span>
                                            }
                                            {
                                                isCutOffNoel && 
                                                <span className='mr-3'>Cutoff noel</span>
                                            }
                                            {
                                                isCutOffNewYear && 
                                                <span className='mr-3'>Cutoff new year</span>
                                            }
                                        </div>
                                        {
                                            itemScan !== null && (
                                                <div className="fileIn">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <ItemImage
                                                                image={image}
                                                                size={size}
                                                                previewImage={preview_image}
                                                                orderId={_id}
                                                                status={production_status}
                                                                type={type}
                                                                batchItem={batchItem}
                                                                item_number={item_number}
                                                                safezoneImage={safezone_image}
                                                                piece_errors={piece_errors}
                                                                piece_hovers={piece_hovers}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    {!!partials && partials.length > 0 &&
                                        <div className="col-auto ml-auto" style={{marginTop: -25}}>
                                            <h2>Đánh dấu mảnh lỗi</h2>
                                            <div className="error-details mb-3">
                                                {
                                                    partials.map((item, index) => (
                                                        <button
                                                            key={index}
                                                            type="button"
                                                            className={`btn ${item.mark_error ? 'error-show' : ''}`}
                                                            onClick={() => this._handleShowItemError(item)}
                                                            onMouseOut={() => this._hanldeMouseOut(item)}
                                                            onMouseOver={() => this._hanldeMouseOver(item)}
                                                        >{item.name}</button>
                                                    ))
                                                }
                                            </div>
                                        </div>}
                                    {itemScan !== null && <div className="col-auto ml-auto" style={{marginTop: -25}}>
                                        <h2 className='text-center'>Chi tiết lỗi</h2>
                                        <div className="error-reason mb-3">
                                            {
                                                reason_error.map((item, index) => (
                                                    <button
                                                        key={index}
                                                        type="button"
                                                        className={`btn ${item.mark_error ? 'error-show' : ''}`}
                                                        onClick={() => this._handleShowReasonItemError(item)}
                                                    >{item.name}</button>
                                                ))
                                            }
                                        </div>
                                    </div>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MarkItemPrinted
